import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { fetchStudents } from "../../../store/middleware";

function StudentsFilter() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { contract } = useSelector((state) => state.b2bContractsReducer);

  const [filter, setFilter] = useState({
    pageNumber: 1,
    pageSize: 100,
    name: "",
    email: "",
    active: "",
    status: "",
    activePlan: "",
    activeStudent: "",
  });

  const applyFilters = async (e) => {
    e.preventDefault();

    const newFilter = { ...filter, contractId: contract.id };
    dispatch(fetchStudents(newFilter));
  };

  const clearFilters = async () => {
    setFilter({
      pageNumber: 1,
      pageSize: 100,
      name: "",
      email: "",
      active: "",
      status: "",
      activePlan: "",
      activeStudent: "",
    });
    const newFilter = {
      pageNumber: 1,
      pageSize: 100,
      name: "",
      email: "",
      active: "",
      status: "",
      activePlan: "",
      activeStudent: "",
      contractId: contract.id,
    };
    dispatch(fetchStudents(newFilter));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter((state) => ({ ...state, [name]: value }));
  };

  return (
    <div className="bigBox">
      <h2>
        <i className="fa fa-filter" aria-hidden="true"></i>Filters
      </h2>
      <form method="post" onSubmit={applyFilters} style={{ margin: 0 }}>
        <div className="formulario">
          <div className="lineInput">
            <label>{t("NAME")}</label>
            <input placeholder="Student name" name="name" onChange={handleChange} value={filter.name} />
          </div>

          <div className="lineInput">
            <label>{t("EMAIL")}</label>
            <input placeholder="Email" name="email" onChange={handleChange} value={filter.email} />
          </div>

          <div className="lineInput">
            <label>Plan Status</label>
            <select name="activePlan" value={filter.activePlan} onChange={handleChange}>
              <option value="">Select</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <div className="lineInput">
            <label>Student Status</label>
            <select name="activeStudent" value={filter.activeStudent} onChange={handleChange}>
              <option value="">Select</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <div className="lineInput">
            <label>Status</label>
            <select name="status" value={filter.status} onChange={handleChange}>
              <option value="">Select</option>
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>

        <div className="filtersBottom">
          <div className="items tiny"></div>
          <div className="items large text-center">
            <div className="show-extras"></div>
          </div>
          <div
            className="items tiny buttons text-right"
            style={{ widows: "100%", display: "flex", justifyContent: "flex-end" }}
          >
            <button type="button" className="btn-clear-filter" onClick={clearFilters}>
              {t("CLEAR_FILTERS")}
            </button>
            <button type="submit" className="btn-filter">
              {t("FILTER")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default StudentsFilter;
